import { baseUrl } from "./config";

/**
 * Product session API base — must match invokeApi routing.
 * Learnix apps call the API host directly (no edge /api rewrite on admin/portal yet).
 * Unset API_BASE_URL → same-origin /api (Vite proxy in local only).
 */
export function getLearnixProductApiBase() {
  const origin = (baseUrl || "").replace(/\/$/, "");
  if (!origin) return "/api";
  return `${origin}/api`;
}

export function createLearnixProductApiConfig() {
  return {
    apiBase: getLearnixProductApiBase(),
    csrf: true,
    csrfPath: "/general_routes/csrf_token",
  };
}
